import { useNavigate } from "@tanstack/react-router";
import { PageHeader } from "@/components/ui";
import { Route } from "@/routes/_authed-tw/admin/ordenes-compra/$id";
import { useOrdenCompraAdmin } from "../hooks/use-ordenes-compra";
import { OrdenCompraForm } from "./OrdenCompraForm";

/**
 * Ruta dedicada de edición de una OC (`/admin/ordenes-compra/$id`, por el id de la
 * versión · la clave puede repetirse entre años fiscales). Carga esa versión y
 * renderiza el form maestro-detalle · al guardar o cancelar regresa al listado.
 */
export function AdminEditarOrdenCompraPage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data: oc } = useOrdenCompraAdmin(id);

  const volver = () => void navigate({ to: "/admin/ordenes-compra" });
  const etiqueta = oc.fecha ? `${oc.clave} · ${new Date(oc.fecha).getFullYear()}` : oc.clave;

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <PageHeader
        title={`Editar orden de compra ${etiqueta}`}
        description="Editar la OC crea una versión nueva · los conceptos y entradas provienen del XML."
        breadcrumbs={[
          { label: "Inicio", href: "/dashboard" },
          { label: "Admin", href: "/admin" },
          { label: "Órdenes de compra", href: "/admin/ordenes-compra" },
          { label: etiqueta },
        ]}
      />
      <OrdenCompraForm inicial={oc} onDone={volver} />
    </div>
  );
}
